import { AccessEvent, MobileOpCode } from 'graphql/generated/graphqlTypes';
import { generateMockAccessEventDoor } from './accessEventDoor';
import { generateMockAccessEventVisitor } from './accessEventVisitor';

export function generateMockAccessEvent({
  action = MobileOpCode.AccessDenied,
  createdAt = 'mockCreatedAt',
  door = generateMockAccessEventDoor({}),
  id = 'mockAccessEventId',
  reason = null,
  visitor = generateMockAccessEventVisitor({})
}: Partial<Omit<AccessEvent, '__typename'>>): AccessEvent {
  return {
    __typename: 'AccessEvent',
    action,
    createdAt,
    door,
    id,
    reason,
    visitor
  };
}
